import { StyleSheet } from 'react-native';
import { Svg, Path } from 'react-native-svg';
import { View } from '../Themed';

// import useWindowDimensions from '../../hooks/useWindowDimensions';

export default function BackgroundDesign() {
  // const windowDimensions = useWindowDimensions();

  return (
    <View
      style={{
        ...StyleSheet.absoluteFillObject,
        zIndex: -1,
      }}
      key="BackgroundDesign"
    >
      <Svg height={600} width={1200} viewBox="0 0 10 5">
        <Path d="M 0,5 C 10,5 10,0 10,0 L 0,0 Z" fill="#f6f6f6" />
      </Svg>
    </View>
  );
}
